export const NEW_ONBOARDING_CUTOFF_DATE = new Date('2026-09-10T19:00:00Z');
